import { Button, Tooltip, type TableRef, Typography } from '@eye-able/ui';
import { DownloadIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { RefObject } from 'react';

interface TableHeadingProps {
  /**
   * React ref object for the table to enable exporting data
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tableRef: RefObject<TableRef<any>>;
  /**
   * The title to display in the table header
   */
  title: string;
}

const TableHeading = ({ title, tableRef }: TableHeadingProps) => {
  const { t } = useTranslation();

  return (
    <Typography tag='div' variant='headline-s'>
      <h2 className='eye:inline'>{title}</h2>
      {'\u00a0'}
      <span className='eye:inline-flex eye:align-middle eye:shrink-0'>
        <Tooltip content={t('exportAllRows')}>
          <Button
            size='icon'
            variant='ghost'
            onClick={() => tableRef.current?.exportTableData()}
          >
            <DownloadIcon aria-label={t('exportAllRows')} />
          </Button>
        </Tooltip>
      </span>
    </Typography>
  );
};

export default TableHeading;
